module.exports = __webpack_public_path__ + "img/BLITZ POSITANO-1467.fa5637c1.jpg";